<script setup lang="ts">
import { ref } from 'vue';
import { BookOpen, LoaderCircle } from 'lucide-vue-next';
import { useRouter } from 'vue-router';
import { cl_errorMessage } from '@/api';
import { useAuthStore } from '@/stores/auth';

const cl_auth = useAuthStore();
const cl_router = useRouter();
const cl_mode = ref<'login' | 'register'>('login');
const cl_email = ref(''); const cl_password = ref(''); const cl_displayName = ref('');
const cl_loading = ref(false); const cl_error = ref('');

async function cl_submit() {
  cl_loading.value = true; cl_error.value = '';
  try {
    if (cl_mode.value === 'login') await cl_auth.cl_login(cl_email.value, cl_password.value);
    else await cl_auth.cl_register(cl_email.value, cl_password.value, cl_displayName.value);
    await cl_router.push('/');
  } catch (cl_cause) { cl_error.value = cl_errorMessage(cl_cause); }
  finally { cl_loading.value = false; }
}
</script>

<template>
  <section class="cl-auth-page">
    <div class="cl-auth-brand"><span><BookOpen /></span><h1>AI Phonics Coach</h1><p>听清每个音，说好每个词。</p></div>
    <form class="cl-auth-form" @submit.prevent="cl_submit">
      <div class="cl-segmented"><button type="button" :class="{ active: cl_mode === 'login' }" @click="cl_mode = 'login'">登录</button><button type="button" :class="{ active: cl_mode === 'register' }" @click="cl_mode = 'register'">注册</button></div>
      <label v-if="cl_mode === 'register'">家长称呼<input v-model.trim="cl_displayName" autocomplete="name" required maxlength="40" /></label>
      <label>邮箱<input v-model.trim="cl_email" type="email" autocomplete="email" inputmode="email" required /></label>
      <label>密码<input v-model="cl_password" type="password" :autocomplete="cl_mode === 'login' ? 'current-password' : 'new-password'" minlength="10" required /></label>
      <p v-if="cl_error" class="cl-form-error">{{ cl_error }}</p>
      <button class="cl-primary-button" type="submit" :disabled="cl_loading"><LoaderCircle v-if="cl_loading" class="cl-spin" />{{ cl_mode === 'login' ? '进入学习' : '创建家长账户' }}</button>
      <RouterLink v-if="cl_mode === 'login'" class="cl-text-link" to="/reset-password">忘记密码</RouterLink>
    </form>
  </section>
</template>
